import TradeItem from '@/models/TradeItem';
import TradeItemsService from '@/services/TradeItemsService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const useTradeItemsStore = defineStore('trade_items', {
  state: () => ({
    selectedTradeItems: new Set(),
  }),

  getters: {
    models: () => useRepo(TradeItem),
  },

  actions: {
    async fetchTradeItems(projectId: Id) {
      const [data, error] = await TradeItemsService.index(projectId);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async createTradeItem(projectId: Id, request: ApiRequests['api.v1.trade-items.store']) {
      const [data, error] = await TradeItemsService.create(projectId, request);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data.data;
    },

    async updateTradeItem(id: Id, request: ApiRequests['api.v1.trade-items.update']) {
      const [data, error] = await TradeItemsService.update(id, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async show(id: Id) {
      const [data, error] = await TradeItemsService.show(id);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async deleteTradeItem(id: Id) {
      const [data, error] = await TradeItemsService.delete(id);

      if(error) {
        throw error;
      }

      this.models.destroy(data.trade_item.id);

      this.models.save(data.sort_order);

      return data;
    },

    async updateSort(id: Id, form: ApiRequests['api.v1.trade-items.sort']) {
      const [data, error] = await TradeItemsService.updateSort(id, form);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },
  },
});
